import { useQuery } from 'react-query';
import { getData } from './api';
export default function useBuildingContacts(buildingId, enabled) {
    return useQuery([buildingId], function () { return getData("/buildings/" + buildingId + "/csv"); }, {
        enabled: enabled,
        refetchOnWindowFocus: false
    });
}
